import dayjs from "dayjs"

import useUser from "@hooks/useUser"

import useJobTimelineViewBryntumInstances from "./useJobTimelineViewBryntumInstances"
import useJobTimelineViewStates from "./useJobTimelineViewStates"

export default function useJobTimelineViewSchedulerConfig() {
    const { user } = useUser()

    const { schedulerPro } = useJobTimelineViewBryntumInstances()

    const { visibleDateRange } = useJobTimelineViewStates()

    const configureSchedulerTimezone = () => {
        return new Promise<void>((resolve) => {
            if (user && schedulerPro.current) {
                schedulerPro.current.instance.timeZone = user.service_company.preferred_timezone

                void schedulerPro.current.instance.project.commitAsync().then(() => {
                    resolve()
                })
            }
        })
    }

    const configureSchedulerDates = () => {
        const schedulerInstance = schedulerPro.current?.instance

        if (schedulerInstance) {
            // (Workaround) Disable infinite scroll while positioning. With it on, setting `visibleDate` shifts the
            // time axis out to the infinite-scroll span without re-measuring the vertical time axis row, and the
            // scroll that follows runs past the stale row height and crashes the RowManager.
            schedulerInstance.infiniteScroll = false
            schedulerInstance.setStartDate(visibleDateRange.start)
            schedulerInstance.setEndDate(visibleDateRange.end)
            schedulerInstance.visibleDate = dayjs(visibleDateRange.start).toDate()
            schedulerInstance.infiniteScroll = true
        }
    }

    return {
        configureSchedulerTimezone,
        configureSchedulerDates,
    }
}
